import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  gap: (p) => p.spacing(0.5),
  backgroundColor: (p) => p.palette.common.white,
  alignItems: 'center',
  flexDirection: 'row',
};

export const title: SxStyle = {
  fontWeight: (p) => p.typography.fontWeightSemiBold,
  fontSize: (p) => p.typography.body3.fontSize,
  color: (p) => p.palette.grey[800],
};

export const icon: SxStyle = {
  color: (p) => p.palette.grey[600],
};

export const infoIcon: SxStyle = {
  color: (p) => p.palette.primary[100],
  cursor: 'pointer',
};

export const doneIcon: SxStyle = {
  color: (p) => p.palette.success[600],
  marginX: (p) => p.spacing(0.25),
};

export const content: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.grey[300],
  borderRadius: (p) => p.spacing(1),
  padding: (p) => p.spacing(1, 1.5),
  width: '100%',
};

export const mandatory: SxStyle = {
  fontSize: (p) => p.typography.body5.fontSize,
  color: (p) => p.palette.grey[700],
  backgroundColor: (p) => p.palette.grey[200],
  height: (p) => p.spacing(2),
};

export const iconInfo: SxStyleFunc<{
  open?: HTMLElement | null;
  disabled?: boolean;
}> = ({ open, disabled }) => ({
  color: open
    ? (p) => p.palette.primary[500]
    : disabled
    ? (p) => p.palette.grey[400]
    : (p) => p.palette.grey[500],
  fill: 'none',
  background: open ? (p) => p.palette.primary[50] : 'initial',
  cursor: disabled ? 'unset' : 'pointer',
  borderRadius: (p) => p.spacing(0.5),
});
